import React from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportReviewsData } from "../../../../models/FacilityReportData";
import { ExtendedReviewSummary } from "../../../FacilityReviewSummariesComponents/ExtendedReviewSummary";

interface IReviewsSectionProps {
  reviews?: FacilityReportReviewsData;
}

export const ReviewsSection: React.FunctionComponent<IReviewsSectionProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportDetails.reviewsSection.${key}`);
  const { reviews } = props;

  if (!reviews) {
    return null;
  }

  return (
    <div className="reviews-section white-border-panel facility-report-details-section">
      <h2>{t("title")}</h2>
      <ExtendedReviewSummary
        locationTitle={undefined}
        reviewSummary={reviews.review_summary}
        showDownloadButtons={false}
      />
    </div>
  );
};
